// Vendor imports
const qs = require('qs')
// Client V1 imports
const { track } = require('client/lib/analytics')

// Action types

const CLOSE = 'STUMBLE_UPON_SUBMIT_MODAL_CLOSE'
const OPEN = 'STUMBLE_UPON_SUBMIT_MODAL_OPEN'

// Action creators

function close() {
  return { type: CLOSE }
}

function open(url) {
  return {
    type: OPEN,
    payload: {
      url: normalizeUrl(url)
    }
  }
}

// Action dispatchers

function maybeOpen() {
  return async function (dispatch, getState) {
    const { router } = getState()
    const queryParams = qs.parse(router.location.search, {
      ignoreQueryPrefix: true
    })
    if (queryParams.su === 'submit') {
      dispatch(open(queryParams.url))
      await track('su-submit-modal')
    }
  }
}

module.exports = {
  // Action types
  CLOSE,
  OPEN,
  // Action creators
  close,
  open,
  // Action dispatchers
  maybeOpen
}

// Action helpers

const URL_PROTOCOL_REGEXP = /^(https?:\/\/)?(.*)/

function normalizeUrl(url) {
  // Ensure the URL has a protocol (default to http://)
  const match = URL_PROTOCOL_REGEXP.exec(url || '')
  if (match) {
    return (match[1] || 'http://') + match[2]
  }
}
